import React from 'react'
import styled from 'styled-components'
import standard_date_choice_wrapperStyles from './standard_date_choice_wrapper.styles'

const apAtomName = {ap_atom_name: 'apStandardDateChoiceAtom'}

const StyledWrapper = styled(props => <div {...props} />)`
  ${standard_date_choice_wrapperStyles}
`

const StandardDateChoiceWrapperAtom: React.FC = function ({children}) {
  return <StyledWrapper {...apAtomName}>{children}</StyledWrapper>
}

export default StandardDateChoiceWrapperAtom
